import { Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { NbMenuService, NbSidebarService } from "@nebular/theme";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import * as cloneDeep from "lodash/cloneDeep";
import { UserData } from "../../../@core/data/users";
import { AnalyticsService } from "../../../@core/utils";
import { AMBIENTE } from "../../../app.config";
import { Paginacao, Usuario } from "../../../model";
import { CambioService, LoginService, ParametroService, UsuarioService, Util } from "../../../services";

@Component({
    selector: "ngx-header",
    styleUrls: ["./header.component.scss"],
    templateUrl: "./header.component.html",
})
export class HeaderComponent implements OnInit {
    @Input() position = "normal";

    @Input() usuario: Usuario;

    @Input() NomeAgencia: string;

    @ViewChild("contentSenha") contentSenha: ElementRef;
    @ViewChild("contentAssinatura") contentAssinatura: ElementRef;

    userMenuPt = [
        { title: "Perfil", target: "1" },
        { title: "Alterar Senha", target: "2" },
        { title: "Alterar Assinatura", target: "4" },
        { title: "Sair", target: "3" },
    ];
    userMenu = [];

    logoempresa: string = "";
    parametroBusca: string = "";
    parametroId: any = "";

    mensagemErro = "";
    mensagemSuccesso = "";
    dadoscambio: any;
    dadosClone = [];

    paginacao: Paginacao = new Paginacao();
    modalSenhaAberto: boolean = false;
    modalAssinaturaAberto: boolean = false;
    modalSenhaRef: any = null; // Referência do modal de senha
    constructor(
        private sidebarService: NbSidebarService,
        private menuService: NbMenuService,
        private userService: UserData,
        private analyticsService: AnalyticsService,
        private loginService: LoginService,
        private parametroService: ParametroService,
        private router: Router,
        private usuarioService: UsuarioService,
        private cambioService: CambioService,
        private modalService: NgbModal,
        private translate: TranslateService
    ) {}

    ngOnInit() {
        this.useLanguage(this.usuario && this.usuario.Agencia ? this.usuario.Agencia.Idioma : "pt");
        // setTimeout(() => this.tratamentosInit(), 800);
        this.tratamentosInit();
        this.buscar();

        document.querySelector(".scrollable-container").addEventListener("scroll", this.scrollListener, true);
    }

    buscarSSO(): string {
        // this.usuarioService.singleSignOn(this.usuario.Id).subscribe(
        //     dados => {
        //         dados.URLsSingleSignOn.forEach(dicionario => {
        //             var urlSSO = dicionario[Object.keys(dicionario)[0]];
        //             window.open(urlSSO, '_blank');
        //         });

        //         if (dados.Erros.length > 0) {
        //             console.log('Erros ao tentar fazer Single Sign On: ', dados.Erros);
        //             dados.Erros.forEach(erro => {
        //                 alert("Erro ao buscar links do SingleSignOn: " + erro);
        //             });
        //         }
        //     },
        // );

        window.open("https://frt.infotravel.com.br/", "_blank");

        return "";
    }

    lastPos = 0;
    scrollListener(event) {
        const larguraTela = window.innerWidth;
        if (larguraTela > 768) return;

        this.lastPos = event.target.scrollTop;
    }

    tratamentosInit() {
        this.menuService.onItemClick().subscribe(item => {
            if (item.item.target == "3") this.logout();
            if (item.item.target == "1") this.perfil();
            if (item.item.target == "2") this.openModalSenha(this.contentSenha);
            if (item.item.target == "4") this.openModalAssinatura(this.contentAssinatura);
            if (item.item.target == "5" || item.item.target == "6") this.buscarSSO();
        });

        this.verificaTrocarSenha();
        this.verificaAssinatura();

        let user = window.localStorage.getItem("gs57d8");

        if (user != null) {
            this.usuario = JSON.parse(atob(user));

            if (this.logoempresa == "") {
                this.logoempresa = Util.pathImagemApi(
                    this.usuario.Agencia ? this.usuario.Agencia.Empresa.LogoInternet : this.usuario.Empresa.LogoInternet
                );
            }
            
            // Atualiza o menu após carregar o usuário
            if (this.usuario && this.usuario.Agencia) {
                this.useLanguage(this.usuario.Agencia.Idioma || "pt");
            } else if (this.usuario) {
                this.useLanguage("pt");
            }
        }
    }

    /**
     * Verifica se o usuário precisa trocar a senha
     * Sempre busca o usuário atualizado do localStorage para garantir dados sincronizados
     */
    verificaTrocarSenha() {
        // Busca o usuário atualizado do localStorage em vez de usar apenas o @Input()
        const usuarioAtual = this.loginService.user();
        
        if (!usuarioAtual) {
            if (this.usuario && this.usuario.TrocarSenha == undefined) {
                setTimeout(() => this.verificaTrocarSenha(), 600);
            }
            return;
        }
        
        // Atualiza o objeto local do componente com os dados mais recentes
        this.usuario = usuarioAtual;
        
        // Se não precisa mais trocar senha, para de verificar
        if (!usuarioAtual.TrocarSenha) {
            this.modalSenhaAberto = false;
            return;
        }
        
        // Se precisa abrir o modal e ainda não está aberto, abre
        if (usuarioAtual.TrocarSenha && !this.modalSenhaAberto) {
            this.openModalSenha(this.contentSenha);
        }
        
        // Continua verificando apenas se TrocarSenha for undefined (aguardando carregamento)
        if (usuarioAtual.TrocarSenha == undefined) {
            setTimeout(() => this.verificaTrocarSenha(), 600);
        }
    }

    /**
     * Verifica se o usuário precisa registrar a assinatura digitalizada
     * Sempre busca o usuário atualizado do localStorage para garantir dados sincronizados
     */
    verificaAssinatura() {
        // Busca o usuário atualizado do localStorage em vez de usar apenas o @Input()
        const usuarioAtual = this.loginService.user();
        
        if (!usuarioAtual) {
            setTimeout(() => this.verificaAssinatura(), 600);
            return;
        }
        
        // Atualiza o objeto local do componente com os dados mais recentes
        this.usuario = usuarioAtual;
        
        // Verifica se precisa registrar a assinatura
        // Só bloqueia se flAssinaContrato for true (não bloqueia se for false ou null)
        const precisaAssinar = usuarioAtual.flAssinaContrato === true && usuarioAtual.AssinaturaDigitalizada == null;
        
        // Se não precisa mais assinar, para de verificar
        if (!precisaAssinar) {
            this.modalAssinaturaAberto = false;
            return;
        }
        
        // Se precisa abrir o modal e ainda não está aberto, abre
        if (precisaAssinar && !this.modalAssinaturaAberto) {
            this.openModalAssinatura(this.contentAssinatura);
        }
        
        // Continua verificando periodicamente
        setTimeout(() => this.verificaAssinatura(), 600);
    }

    toggleSidebar(): boolean {
        this.sidebarService.toggle(true, "menu-sidebar");

        return false;
    }

    goToHome() {
        this.menuService.navigateHome();
    }

    startSearch() {
        this.analyticsService.trackEvent("startSearch");
    }

    perfil() {
        this.router.navigate(["/perfil"]);
    }

    logout() {
        this.loginService.logout();
    }

    /**
     * Abre o modal de senha
     * O modal não pode ser fechado com ESC ou clicando fora dele
     */
    openModalSenha(content) {
        if (this.modalSenhaAberto) {
            return; // Evita abrir múltiplos modais
        }
        
        this.modalSenhaAberto = true;
        const modalRef = this.modalService.open(content, {
            ariaLabelledBy: "modal-basic-title",
            backdrop: "static",
            centered: true,
            size: "lg",
            keyboard: false, // Desabilita o fechamento com a tecla ESC
        });
        
        // Armazena a referência do modal
        this.modalSenhaRef = modalRef;
        
        // Quando o modal for fechado, atualiza a flag
        modalRef.result.then(
            () => {
                this.modalSenhaAberto = false;
                this.modalSenhaRef = null;
                // Recarrega o usuário após fechar o modal para verificar novamente
                const usuarioAtual = this.loginService.user();
                if (usuarioAtual) {
                    this.usuario = usuarioAtual;
                }
                // Aguarda um pouco antes de verificar novamente para evitar reabertura imediata
                // Se o usuário saiu sem alterar a senha, não deve reabrir imediatamente
                setTimeout(() => {
                    this.verificaTrocarSenha();
                }, 2000);
            },
            () => {
                this.modalSenhaAberto = false;
                this.modalSenhaRef = null;
                // Recarrega o usuário após fechar o modal para verificar novamente
                const usuarioAtual = this.loginService.user();
                if (usuarioAtual) {
                    this.usuario = usuarioAtual;
                }
                // Aguarda um pouco antes de verificar novamente para evitar reabertura imediata
                setTimeout(() => {
                    this.verificaTrocarSenha();
                }, 2000);
            }
        );
    }

    /**
     * Abre o modal de assinatura digitalizada
     * O modal não pode ser fechado com ESC ou clicando fora dele
     */
    openModalAssinatura(content) {
        if (this.modalAssinaturaAberto) {
            return; // Evita abrir múltiplos modais
        }
        
        this.modalAssinaturaAberto = true;
        const modalRef = this.modalService.open(content, {
            ariaLabelledBy: "modal-basic-title",
            backdrop: "static",
            centered: true,
            size: "lg",
            keyboard: false, // Desabilita o fechamento com a tecla ESC
        });
        
        // Quando o modal for fechado, atualiza a flag
        modalRef.result.then(
            () => {
                this.modalAssinaturaAberto = false;
                // Recarrega o usuário após fechar o modal para verificar novamente
                const usuarioAtual = this.loginService.user();
                if (usuarioAtual) {
                    this.usuario = usuarioAtual;
                }
                // Verifica novamente se precisa assinar
                this.verificaAssinatura();
            },
            () => {
                this.modalAssinaturaAberto = false;
                // Recarrega o usuário após fechar o modal para verificar novamente
                const usuarioAtual = this.loginService.user();
                if (usuarioAtual) {
                    this.usuario = usuarioAtual;
                }
                // Verifica novamente se precisa assinar
                this.verificaAssinatura();
            }
        );
    }

    /**
     * Método chamado quando a senha é alterada ou quando o modal é fechado
     */
    senhaAlterada(dados) {
        // Recarrega o usuário do localStorage para garantir que está atualizado
        const usuarioAtual = this.loginService.user();
        if (usuarioAtual) {
            this.usuario = usuarioAtual;
        }
        
        // Se a senha foi alterada com sucesso (indicado pelo evento), fecha a modal e faz logout
        if (dados && dados.senhaAlterada) {
            // Marca que a modal não está mais aberta
            this.modalSenhaAberto = false;
            this.modalSenhaRef = null;
            
            // Fecha todas as modais abertas
            this.modalService.dismissAll();
            
            // Faz logout após um pequeno delay para garantir que a modal foi fechada
            setTimeout(() => {
                this.logout();
            }, 200);
        }
        // Se dados for apenas true (modal fechado sem alterar senha), não faz nada
        // A modal já foi fechada pelo componente senha-form
    }

    /**
     * Método chamado quando a assinatura é atualizada
     */
    assinaturaAlterada(dados) {
        // Recarrega o usuário do localStorage para garantir que está atualizado
        const usuarioAtual = this.loginService.user();
        if (usuarioAtual) {
            this.usuario = usuarioAtual;
            // Atualiza o menu após atualizar o usuário
            const idioma = this.usuario.Agencia ? this.usuario.Agencia.Idioma : "pt";
            this.useLanguage(idioma);
        }
        
        // O modal já foi fechado automaticamente pelo componente de assinatura
        // Apenas atualiza a flag
        this.modalAssinaturaAberto = false;
    }
    buscar() {
        this.mensagemErro = "";
        // this.mensagemSuccesso = '';
        let busca = this.cambioService.buscarPorParametro(this.parametroBusca, this.paginacao.NumeroPagina);
        if (this.parametroId != undefined && this.parametroId != "") {
            this.paginacao.NumeroPagina = 1;
            busca = this.cambioService.buscarPorId(this.parametroId);
        }
        busca.subscribe(
            dados => {
                if (dados) {
                    this.dadoscambio = dados.Items;

                    //cria um clone do objeto cambio, para não alterar os dados do objeto original
                    const dadosClone = cloneDeep(dados);

                    this.dadosClone = dadosClone.Items;

                    this.paginacao.NumeroPagina = dados.MetaData.NumeroPagina;
                    this.paginacao.TotalItens = dados.MetaData.TotalItens;
                    this.paginacao.ItensPorPagina = dados.MetaData.itensPorPagina;
                    this.paginacao.TotalPaginas = dados.MetaData.TotalPaginas;
                } else {
                    this.dadoscambio = null;
                }
            },
            erro => {
                this.dadoscambio = null;
                console.log("Erro ao Buscar");
                console.log(erro);
                this.mensagemErro = this.errorHandler(erro, "Buscar cambio");
            }
        );
    }

    public errorHandler(erro, acao: string = null): string {
        let mensagem = "Erro";
        if (acao !== null) {
            mensagem += " ao tentar " + acao + ": ";
        }
        switch (erro.status) {
            case 0:
                mensagem += "o servidor não respondeu, tente novamente mais tarde!";
                break;
            case 401:
                mensagem += "você não tem autorização para executar esta ação!";
                break;
            case 404:
                mensagem += erro.error.mensagem;
                break;
            case 406:
                mensagem += "a requisição não foi aceita, tente novamente!";
                break;
            case 500:
                mensagem +=
                    "Houve um erro interno no servidor! tente novamente, caso o erro persista, entre em contato com o suporte";
                break;
            default:
                mensagem += erro.statusText;
        }

        return mensagem;
    }

    useLanguage(language: string) {
        this.translate.setDefaultLang(language);
        this.translate.use(language);

        const menuClone = cloneDeep(this.userMenuPt);

        // Filtra o menu baseado nas permissões do usuário
        let menuFiltrado = menuClone;
        
        // Remove "Alterar Assinatura" se o usuário não assina contrato
        if (!this.usuario || this.usuario.flAssinaContrato !== true) {
            menuFiltrado = menuClone.filter(item => item.target !== "4");
        }

        // Adiciona "Infotravel" ao menu filtrado se estiver no ambiente correto
        if (AMBIENTE === "FRT" || AMBIENTE === "HOMOLOGA") {
            // Verifica se já existe para evitar duplicação
            const jaExiste = menuFiltrado.some(item => item.target === "5");
            if (!jaExiste) {
                menuFiltrado.push({ title: "Infotravel", target: "5" });
            }
        }

        //console.log(this.translate.currentLang);

        this.userMenu = menuFiltrado.map(z => {
            this.translate.get(z.title).subscribe((translated: string) => {
                z.title = translated;
            });
            return z;
        });
    }
    // getParametroLogo() {
    //   this.parametroService.buscarPorParametro("logo-operadora", 1).subscribe(
    //     dados => {
    //       this.logooperadora = dados.Items[0];
    //       window.localStorage.setItem('SKI8gR', btoa(JSON.stringify(this.logooperadora)));
    //     },
    //     erros => {
    //       this.logooperadora = "assets/img/notfound.jpg";
    //     },
    //
    //   );
    // }

    // getLogoEmpresaUsuario() {
    //   this.usuarioService.getUserById(this.usuario.Id).subscribe(
    //     dados => {
    //
    //       this.usuario = dados.Items[0];
    //
    //       window.localStorage.setItem('gs57d8', btoa(JSON.stringify(this.usuario)));
    //
    //       if (this.logoempresa == '') {
    //         this.logoempresa = Util.pathImagemApi(this.usuario.Agencia ? this.usuario.Agencia.Empresa.LogoInternet : this.usuario.Empresa.LogoInternet);
    //       }
    //     });
    // }
}
